import { DonationListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';

type PropTypes = {
  t: TFunction;
  productCategories?: Record<number, string>;
};

export const createDonationsTableChipsConfig = ({
  t,
  productCategories,
}: PropTypes): FiltersConfig<DonationListFilterInput> => ({
  bloodTypes: {
    label: t('bloodType'),
    renderValue: (val) => String(val).replace('_', ''),
  },
  locations: {
    label: t('location'),
  },
  productCategories: {
    label: t('category'),
    renderValue: (val) =>
      productCategories ? productCategories[Number(val)] : t('productDonation'),
  },
  ineligible: {
    label: t('status'),
    renderValue: () => t('ineligible'),
  },
  discarded: {
    label: t('status'),
    renderValue: () => t('discarded'),
  },
  failed: {
    label: t('status'),
    renderValue: () => t('failed'),
  },
});

export const excludedFilterFields: (keyof DonationListFilterInput)[] = [
  'searchQuery',
  'fromDate',
  'locationQuery',
  'toDate',
];
